export type TimestampedSale = {
  createdAt?: string | Date | null;
  id?: number | string | null;
};

/** Sort newest sales first, using the sale ID to break identical/invalid dates deterministically. */
export function sortSalesNewestFirst<T extends TimestampedSale>(sales: readonly T[]): T[] {
  return [...sales].sort((a, b) => {
    const aTime = a.createdAt ? new Date(a.createdAt).getTime() : Number.NaN;
    const bTime = b.createdAt ? new Date(b.createdAt).getTime() : Number.NaN;
    const aValid = Number.isFinite(aTime);
    const bValid = Number.isFinite(bTime);
    if (aValid !== bValid) return aValid ? -1 : 1;
    if (aValid && bValid && aTime !== bTime) return bTime - aTime;

    const aId = Number(a.id);
    const bId = Number(b.id);
    if (Number.isFinite(aId) && Number.isFinite(bId) && aId !== bId) return bId - aId;
    return 0;
  });
}
